import { render } from "./VehicleWatchlistButton.vue?vue&type=template&id=54f7641c"
import script from "./VehicleWatchlistButton.vue?vue&type=script&lang=js"
export * from "./VehicleWatchlistButton.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/production/releases/343/listings.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QIcon,QTooltip});
